/**
 * 회차리스트 액션 정의
 */
export enum EpisodeCheckAction {
  SHOW = 'episode action show', // 회차 볼수 있음
  NEED_LOGIN = 'episode action need login', // 로그인 필요
  NEED_MATURE = 'episode action need mature', // 성인 인증 필요
  USE_FREE_TICKET = 'episode action use freeticket', // 사용가능한 티켓 있음
  SHOW_PAYMENT = 'episode action use show payment', // 코인 부족
  NEED_BUY = 'episode action need buy', // 코인으로 구매 가능
  NEED_FREE_BUY = 'episode action need free buy', // 무료회차 소장
  ERROR = 'ERROR', // 오류
}

/**
 * TODO WEBTOON이 아니면 MANGA로 봄
 */
export const ComicType = {
  SRRCK: 1, // WEBTOON
  EPUB: 2, // EPUB
  PUBLICATION: 3, // 출판물
};
